import React, { Component } from "react";
import { Card, CardBody, Col, Row, CardTitle, Alert,Container,Button,Table,Badge,CardFooter,Modal,Label,FormGroup,Input } from "reactstrap";
import { AvForm, AvField,AvInput  } from 'availity-reactstrap-validation';
import {CustomPagination} from "../Common/CustomPagination";
import {DataTabeSearch} from '../Common/DataTabeSearch'
// Redux
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';
import { createVehicleType,vehicleTypeList,editVehicleType} from '../../../store/vehicleType/actions';
import VehicleType from "../../../store/vehicleType/reducer";

class VehicleTypeCreate extends Component {
    constructor(props) {
        super(props);
        this.state = {
                page: 1,
                per_page: 10,
                search: '',
                customchk: true,
                toggleSwitch: false,
                edittoggleSwitch: false,  
                modal_scroll: false,
                vehicleType: {
                    
                }
            };
        // this.tog_scroll = this.tog_scroll.bind(this);
    }

    componentDidMount()
    {
            this.fetchvehicleTypeList();    
    }

    fetchvehicleTypeList = () => {
        let options = {
            page: this.state.page,
            per_page: this.state.per_page,
            search: this.state.search
        }
        vehicleTypeList(options).then((response) => {
            this.setState({
                vehicleTypeList :response.data, 
            });
        })
        .catch((err) => {
            console.log(err);
        })
    }

    //modal
    tog_scroll = (vehicleType) => {
        this.setState(prevState => ({
          modal_scroll: !prevState.modal_scroll,
        }));
        this.state.vehicleType = vehicleType;
        this.removeBodyCss();
      }

      removeBodyCss() {
        document.body.classList.add("no_padding");
      }


      autoSearchInputChange = (event) => {
        event.preventDefault();
        const { target: { name, value } } = event;
        // this.updateDesignationObject(name, value);
      }
      
      // handleValidSubmit
        handleValidSubmit(event, values) {   
            values = Object.entries(values).reduce((a,[k,v]) => (v == null || v == "" ? a : (a[k]=v, a)), {});
            console.log("inm",values)   

            this.props.createVehicleType(values);

            this.form && this.form.reset();
            this.fetchvehicleTypeList();    
        }
       
       handleEditSubmit(event, values) {  
            this.props.editVehicleType(Object.entries(values).reduce((a,[k,v]) => (v == null || v == "" ? a : (a[k]=v, a)), {}));
            this.setState(prevState => ({
                modal_scroll: !prevState.modal_scroll,
              }));
            // this.fetchvehicleTypeList();  
       }

       handleInputChange = (e) => {
        this.setState({[e.target.name]: e.target.value},() => {
            this.fetchvehicleTypeList();
        });
       }

       handlePageClick = (e, index) => {
            e.preventDefault()
            this.setState({
                page: index
            },() => {
                this.fetchvehicleTypeList();
            });
        }

    render() {
        let vehicleTypeList = [];
        let paginator;
        if (this.state.hasOwnProperty('vehicleTypeList')) {
            vehicleTypeList = this.state.vehicleTypeList.data;
            paginator = {
                'currentPage':this.state.vehicleTypeList.currentPage,
                'pagesCount':this.state.vehicleTypeList.pagesCount,
                'total':this.state.vehicleTypeList.total,
                'to':this.state.vehicleTypeList.to,
                'from':this.state.vehicleTypeList.from,
            }
        }
        const {id,vehicle_type_name_bn,vehicle_type_name_en,charge_count_hour,grace_period,priority} = this.state.vehicleType;
        const getBadge = (status) => {
            return status == 1 ? 'success' : 'secondary'
          }
          
          const getStatusValue = (status) => {
              return status == 1 ? 'Active' : 'In-active'
          }
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid={true}>

                        <Breadcrumbs title="Settings" breadcrumbItem="Vehicle Type" />
                        {this.props.error && this.props.error ? <Alert color="danger">{this.props.error}</Alert> : null}
                        {this.props.success && this.props.success ? <Alert color="success">{this.props.success}</Alert> : null}
                        <Row>
                        <Col lg="6" md="6">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Vehicle Type List</CardTitle>
                                        <div className="table-responsive">
                                        <DataTabeSearch handleInputChange={this.handleInputChange}/>
                                            <Table className="table mb-0">

                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Vehicle Type Name</th>
                                                        <th>Vehicle Type Name (Bangla)</th>
                                                        <th>Charge Count Hour </th>
                                                        <th>Grace Period</th>
                                                        <th>Priority</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                {vehicleTypeList.map((vehicleType, index) =>
                                                    <tr key={vehicleType.id.toString()}>
                                                        <td scope="row">{index+1}</td>
                                                        <td>{vehicleType.vehicle_type_name_en}</td>
                                                        <td>{vehicleType.vehicle_type_name_bn}</td>
                                                        <td>{vehicleType.charge_count_hour}</td>
                                                        <td>{vehicleType.grace_period}</td>
                                                        <td>{vehicleType.priority}</td>
                                                        <td><button type="button"
                                                               className="btn btn-sm btn-primary waves-effect waves-light"
                                                               onClick={() => { this.tog_scroll(vehicleType) }} 
                                                               data-toggle="modal"
                                                             >Edit</button>
                                                            </td>
                                                       </tr>
                                                )}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </CardBody>
                                    {paginator &&
                                     <CardFooter className="p-6">
                                          <CustomPagination paginator={paginator} handlePageClick={this.handlePageClick} />
                                      </CardFooter>
                                      }
                                </Card>
                                <Modal
                                 isOpen={this.state.modal_scroll}
                                   toggle={this.tog_scroll}
                                   scrollable={true}
                                   >
                                   <div className="modal-header">
                                       <h5 className="modal-title mt-0">{vehicle_type_name_en}</h5>
                                       <button
                                       type="button"
                                       onClick={() =>
                                           this.setState({ modal_scroll: false })
                                       }
                                       className="close"
                                       data-dismiss="modal"
                                       aria-label="Close"
                                       >
                                       <span aria-hidden="true">&times;</span>
                                       </button>
                                   </div>
                                   <div className="modal-body">
                                   <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleEditSubmit(e,v) }}>
                                       {this.props.msg && this.props.msg ? (
                                           <Alert color="success">
                                               Vehicle Type Updated Successfully!
                                           </Alert>
                                           ) : null}
                                                <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Vehicle Type Name"  id="vehicle_type_name_en" name="vehicle_type_name_en" value={vehicle_type_name_en} />
                                                     <AvField name="id" id="id" value={id}  type="hidden"  />
                                                </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Vehicle Type Name(Bangla)"  id="vehicle_type_name_bn" name="vehicle_type_name_bn" value={vehicle_type_name_bn} />
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="number" label="Charge Count Hour"  id="charge_count_hour" name="charge_count_hour" value={charge_count_hour}/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="number" label="Grace Period"  id="grace_period" name="grace_period" value={grace_period}/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="number" label="Priority"  id="priority" name="priority" value={priority}/>
                                                 </div>

                                           <div className="text-center mt-4">
                                                <button type="button" className="btn btn-light mr-2" onClick={this.tog_scroll}>Close</button>
                                                <button type="submit" className="btn btn-success save-event">Save</button>
                                           </div>
                                   </AvForm>
                                   </div>
                               </Modal>
                            </Col>
                            <Col lg="6" md="6">
                                <Card>
                                    <CardBody>
                                        <CardTitle>Create Vehicle Type </CardTitle>
                                        
                                        <AvForm className="form-horizontal" onValidSubmit={(e,v) => { this.handleValidSubmit(e,v) }} ref={c => (this.form = c)}>
                                                <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Vehicle Type Name"  id="vehicle_type_name_en" name="vehicle_type_name_en" />
                                                </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="text" label="Vehicle Type Name(Bangla)"  id="vehicle_type_name_bn" name="vehicle_type_name_bn"/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="number"  value="1" label="Charge Count Hour"  id="charge_count_hour" name="charge_count_hour"/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="number" label="Grace Period"  id="grace_period" name="grace_period"/>
                                                 </div>

                                                 <div className="col-md-12">
                                                     <AvField className="form-control" type="number" label="Priority"  id="priority" name="priority"/>
                                                 </div>
                                             <div className=" mt-4">
                                                 <Button type="submit" color="success">Submit</Button>
                                             </div>
                                         </AvForm>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

const mapStatetoProps = state => {
    const { msg,error,success } = state.VehicleType;
    console.log(msg)
    console.log(error)
    console.log(success)
    return { msg,error,success };
}

export default withRouter(connect(mapStatetoProps, { createVehicleType,editVehicleType })(VehicleTypeCreate));
